import { Stack } from '@mui/material';

import useIsNewTrainingUIEnabled from '@/hooks/useIsNewTrainingUIEnabled';

import Changelog from './Changelog';
import DedicatedDeployments from './DedicatedDeployments';
import Details from './Details';
import Learn from './Learn';
import ModelAPIs from './ModelAPIs';
import Training from './Training';
import TrainingLegacy from './Trainings';
import { Content } from './styled';

function Overview() {
  const isNewTrainingUIEnabled = useIsNewTrainingUIEnabled();

  return (
    <Stack direction="row" height="100%">
      <Content>
        <DedicatedDeployments />
        <ModelAPIs />
        {isNewTrainingUIEnabled ? <Training /> : <TrainingLegacy />}
        <Learn />
        <Changelog />
      </Content>
      <Details />
    </Stack>
  );
}

export default Overview;
